<template>
  <div class="maskComponent">
    <div class="mask">
      <img class="close" @click="closeMask" src="../../assets/images/close.png" alt />
      <template>
        <el-carousel indicator-position="outside" :initial-index="initialIndex">
          <el-carousel-item v-for="(item,index) in getMaskImgList" :key="index">
            <img :src="'http://'+item" alt />
            <!-- <el-button class="delet" @click="deletImg(index)" type="danger">删除</el-button> -->
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    imgListProp: null,
    initialIndexProp: null
  },
  data() {
    return {
      initialIndex: 0
    };
  },

  mounted() {
    console.log(123);
  },

  computed: {
    getMaskImgList: function() {
      if (typeof this.imgListProp == "string" && this.imgListProp != null) {
        this.initialIndex = 0;
        let arr = []
        arr.push(this.imgListProp);
        return arr
      }
    }
  },

  methods: {
    closeMask(){
      this.$emit('closeMask', false)
    }
  }
};
</script>

<style lang="less">
.maskComponent {
  .mask .el-carousel__item {
    background: transparent;
    opacity: 1!important;
  }
  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    .close {
      width: 20px;
      position: absolute;
      top: 0px;
      right: 300px;
      padding: 50px;
      z-index: 100;
    }
    .delet {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 100px;
      z-index: 100;
      height: auto !important;
    }
    .download {
      border: none;
      background: #22ca85;
      color: #ffffff;
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 250px;
      z-index: 100;
      height: auto !important;
    }
    .edit {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 240px;
      z-index: 100;
      height: auto !important;
    }

    .el-carousel__container {
      margin: 0 auto;
      width: 80%;
      height: 90vh;
      z-index: 99;
      .el-carousel__arrow {
        font-size: 50px !important;
        padding: 20px;
        width: 100px;
        height: 100px;
      }
      // .el-carousel__arrow--left,.el-carousel__arrow--right{

      // }
    }

    .el-carousel__item {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      // min-height: 400px;
      .uploadtime {
        width: 100%;
        line-height: 24px;
        color: #fff;
        position: absolute;
        left: 100px;
        bottom: 0;
      }
      > img {
        height: 90%;
      }
    }
    .door_modle_introduced {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      padding: 0 100px;
      .introduced_toward {
        display: flex;
        flex-direction: column;
        > span {
          font-size: 14px;
          color: #ffffff;
        }

        .el-textarea {
          margin-top: 10px;
          .el-textarea__inner {
            width: 260px;
            height: 60px;
            background: #f5f5f5;
            border: 1px solid #ccc;
          }
        }
      }
      .el-select {
        margin-top: 10px;
        .el-input {
          .el-input__inner {
            padding-left: 10px !important;
            font-size: 16px !important;
            width: 100px !important;
            height: 30px !important;
            background: #f5f5f5;
            border: 1px solid #ccc !important;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
    }

    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }

    // .el-carousel__item:nth-child(2n+1) {
    //   background-color: #d3dce6;
    // }
  }
}
</style>